<template>
  <b-container fluid>
    <header class="masthead bg-primary text-white text-center">
      <div class="b-container d-flex align-items-center flex-column">
        <!-- Masthead Avatar Image-->
        <img
          class="masthead-avatar mt-0 mb-4"
          src="../assets/img/robot.png"
          alt="Robot"
        />
        <!-- Masthead Heading-->
        <h6 class="masthead-heading test-uppercase mb-0">
          Plataforma Web
          <p>de Inteligência Artificial</p>
        </h6>
        <!-- Icon Divider-->
        <div class="divider-custom divider-light">
          <div class="divider-custom-line"></div>
          <div class="divider-custom-icon"><i class="fas fa-brain"></i></div>
          <div class="divider-custom-line"></div>
        </div>
        <!-- Masthead Subheading-->
        <p class="pre-wrap masthead-subheading font-weight-light mb-5">
          Para contribuir para o ensino da IA e em sintonia com a iniciativa 
          <b-link class ="text-white" href="https://ai4k12.org/" target="_BLANK"><ins>AI4K12</ins></b-link> !
         </p>
      </div>
    </header>
    <footer class="footer text-center">
      <div class="b-container>">
        <div class="row">
          <!-- Footer Location-->
          <div class="col-lg-7">
            <h4 class="mb-0">Localização</h4>
            <p class="pre-wrap lead mb-0">Universidade dos Açores - FCT (<b-link class ="text-white" href="https://gria.uac.pt" target="_BLANK"><ins>GRIA</ins></b-link>)</p>
            <p>Ponta Delgada</p>
          </div>
          <!-- Footer About Text-->
          <div class="col-lg-4">
            <h4 class="mb-0">Sobre Web <small>&</small> IA</h4>
            <p class="pre-wrap lead mb-0">
              Web <small>&</small> IA usa Bootstrap com licença MIT e Framework Vue.Js
              </p>
          </div>
        </div>
      </div>             
    </footer>
    <!-- Copyright Section-->
    <section class="copyright py-4 text-center text-white">
      <div class="b-container>">
        <small class="pre-wrap">Copyright © Web <small>&</small> IA 2021</small>
      </div>
    </section>
    <!-- Scroll to Top Button (Only visible on small and extra-small screen sizes)-->
    <div class="scroll-to-top d-lg-none position-fixed">
      <a
        class="js-scroll-trigger d-block text-center text-white rounded"
        href="#page-top"
        ><i class="fa fa-chevron-up"></i
      ></a>
    </div>
  </b-container>
</template>

<script>
import router from "@/router/index";

export default {
  methods: {
    registo() {
      router.push({ name: "Registo" });
    },
    contato(){
      router.push({name: "Contato"});
    },
    repositorio(){
      router.push({name: "Repositorio"});
    },
    AI4K12(){
      router.push({name: "AI4K12"});
    }
  
  },
}
</script>
